import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Box,
  Typography,
  Container,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

import Plataformas from './Plataformas_4';
import FormularioBancario from './FormularioBancario_5';
import FormularioDocumentos from './FormularioDocumentos_6';
import FormularioEndereco from './FormularioEndereco_3';
import FormularioDados from './FormularioDados_2';
import FormularioFiliacaoUBC from './FormularioFiliacaoUBC_1';

import FormularioFiliacaoUBCPJ from './FormularioFiliacaoUBC_1_PJ';
import FormularioDadosPJ from './FormularioDados_2_PJ';
import FormularioDocumentosPJ from './FormularioDocumentos_6_PJ';
import TelaDesligamentos from './TelaDesligamentos';
import TelaLoadind from './TelaLoading';

import html2pdf from 'html2pdf.js';
import moment from 'moment';

import { useLocation } from 'react-router-dom';

import {
  mapeamentoEtapaUmPF,
  mapeamentoEtapaDoisPF,
  mapeamentoEtapaTres,
  mapeamentoEtapaQuatro,
  mapeamentoEtapaCinco,
  mapeamentoEtapaArquivos,
} from '../mapeamentoDTO';
import {
  serviceCriarFiliacao,
  serviceSalvarArquivos,
  serviceEnviaEmail,
  serviceSalvarLog,
  serviceRecuperaHash
} from '../Service/service';

function setBase64LocalStorage(key, value) {
  if (!value.length || value.length === 0) return;
  const encoded = btoa(JSON.stringify(value));
  localStorage.setItem(key, encoded);
}

function getBase64LocalStorage(key) {
  const item = localStorage.getItem(key);
  if (!item) return null;
  return JSON.parse(atob(item));
}

function getInitialData() {
  const savedData = getBase64LocalStorage('dadosFormulario');
  return savedData || [];
}

function getInitialEtapa() {
  const savedStep = getBase64LocalStorage('etapa');
  return savedStep !== null ? savedStep : 0;
}

function clearLocalStorage() {
  localStorage.removeItem('dadosFormulario');
  localStorage.removeItem('etapa');
  localStorage.removeItem('trackId');
}

function getOrCreateTrackId() {
  const saved = localStorage.getItem('trackId');
  if (saved) return saved;
  
  const newTrackId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  localStorage.setItem('trackId', newTrackId);
  return newTrackId;
}

function Orquestrador(props) {
  const [dadosFormulario, setDadosFormulario] = useState(getInitialData);
  const [etapa, setEtapa] = useState(getInitialEtapa);
  const [erroValidacao, setErroValidacao] = useState(false);
  const [nrFiliacao, setNrFiliacao] = useState(0);
  const [finalizado, setFinalizado] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [isLoading, setIsLoading] = useState(false);
  const [bloqueioPorCPFCNPJ, setBloqueioPorCPFCNPJ] = useState(false);
  const [trackId] = useState(getOrCreateTrackId);

  const [openDialog, setOpenDialog] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const idFiliacaoUrl = params.get('idfiliacao');
  const dataHoraUrl = params.get('datahora');
  const hashUrl = params.get('hash');

  const pdfRef = useRef(null);

  const refs = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);

  useEffect(() => {
    const savedData = getBase64LocalStorage('dadosFormulario');
    const savedStep = getBase64LocalStorage('etapa');

    if (savedData) {
      setDadosFormulario(savedData);
    }
    if (savedStep !== null) {
      setEtapa(savedStep);
    }

    if (idFiliacaoUrl && dataHoraUrl && hashUrl) {
      if (hashUrl == 'true') {
        recuperaHashEGeraPDF();
      }
    }

  }, []);

  const recuperaHashEGeraPDF = async () => {
    const hash = await serviceRecuperaHash(idFiliacaoUrl);

    if (hash)
      setTimeout(() => {

        let dadosHash = JSON.parse(atob(hash));
        dadosHash[5].impressao = true;
        dadosHash[0].impressao = true;
        dadosHash[1].impressao = true;
        
        setDadosFormulario(dadosHash);
        setNrFiliacao(idFiliacaoUrl);
        
        setTimeout(async () => {
          const retorno = await salvaDocumentoParaAssinatura(idFiliacaoUrl)
          if (retorno)
            alert('Documento de assinatura gerado com sucesso!')
        }, 500);

      }, 1000);
  }

  useEffect(() => {
    setBase64LocalStorage('dadosFormulario', dadosFormulario);
  }, [dadosFormulario]);

  useEffect(() => {
    setBase64LocalStorage('etapa', etapa);
  }, [etapa]);

  useEffect(() => {
    if (bloqueioPorCPFCNPJ) {
      setOpenDialog(true);
      setDadosFormulario((prev) => {
        const updated = [...prev];
        updated[1].cpf = '';
        updated[1].cnpj = '';
        return updated;
      });
    }
  }, [bloqueioPorCPFCNPJ]);

  const handleChildDataChange = (index, newData) => {
    setDadosFormulario((prev) => {
      const updated = [...prev];
      updated[index] = newData;
      return updated;
    });
  };

  let formularios = [];
  if (props.tipo === 'pf') {
    formularios = [
      <FormularioFiliacaoUBC
        ref={refs.current[0]}
        formData={dadosFormulario[0]}
        onChildDataChange={(data) => handleChildDataChange(0, data)}
        finalizado={finalizado}
      />,
      <FormularioDados
        ref={refs.current[1]}
        formData={dadosFormulario[1]}
        nacionalidade={dadosFormulario[0]?.tipoFiliacao || ''}
        onChildDataChange={(data) => handleChildDataChange(1, data)}
        finalizado={finalizado}
        setEtapa={setEtapa}
        setIsLoading={setIsLoading}
        setBloqueioPorCPFCNPJ={setBloqueioPorCPFCNPJ}
      />,
      <FormularioEndereco
        ref={refs.current[2]}
        formData={dadosFormulario[2]}
        onChildDataChange={(data) => handleChildDataChange(2, data)}
        setEtapa={setEtapa}
        setIsLoading={setIsLoading}
      />,
      <Plataformas
        ref={refs.current[3]}
        formData={dadosFormulario[3]}
        onChildDataChange={(data) => handleChildDataChange(3, data)}
      />,
      <FormularioBancario
        ref={refs.current[4]}
        formData={dadosFormulario[4]}
        nacionalidade={dadosFormulario[0]?.tipoFiliacao || ''}
        onChildDataChange={(data) => handleChildDataChange(4, data)}
      />,
      <FormularioDocumentos
        ref={refs.current[5]}
        formData={dadosFormulario[5]}
        outorgado={dadosFormulario[1]?.falecido === 'true' || false}
        menorQuinze={dadosFormulario[1]?.menorDe15 === 'true' || false}
        onChildDataChange={(data) => handleChildDataChange(5, data)}
        finalizado={finalizado}
        nacionalidade={dadosFormulario[0]?.tipoFiliacao || ''}
      />,
    ];
  } else {
    formularios = [
      <FormularioFiliacaoUBCPJ
        ref={refs.current[0]}
        formData={dadosFormulario[0]}
        onChildDataChange={(data) => handleChildDataChange(0, data)}
        finalizado={finalizado}
      />,
      <FormularioDadosPJ
        ref={refs.current[1]}
        formData={dadosFormulario[1]}
        onChildDataChange={(data) => handleChildDataChange(1, data)}
        finalizado={finalizado}
        setBloqueioPorCPFCNPJ={setBloqueioPorCPFCNPJ}
      />,
      <FormularioEndereco
        ref={refs.current[2]}
        formData={dadosFormulario[2]}
        onChildDataChange={(data) => handleChildDataChange(2, data)}
        setEtapa={setEtapa}
        setIsLoading={setIsLoading}
      />,
      <Plataformas
        ref={refs.current[3]}
        formData={dadosFormulario[3]}
        onChildDataChange={(data) => handleChildDataChange(3, data)}
      />,
      <FormularioBancario
        ref={refs.current[4]}
        formData={dadosFormulario[4]}
        nacionalidade={dadosFormulario[0]?.tipoFiliacao || ''}
        onChildDataChange={(data) => handleChildDataChange(4, data)}
      />,
      <FormularioDocumentosPJ
        ref={refs.current[5]}
        formData={dadosFormulario[5]}
        outorgado={dadosFormulario[1]?.falecido === 'true' || false}
        menorQuinze={dadosFormulario[1]?.menorDe15 === 'true' || false}
        onChildDataChange={(data) => handleChildDataChange(5, data)}
        finalizado={finalizado}
      />,
    ];
  }

  useEffect(() => {
    let intervalId;
    if (sucesso) {
      setCountdown(20);
      intervalId = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(intervalId);
            window.location.href = 'https://www.ubc.org.br/';
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [sucesso]);

  const avancarEtapa = () => {
    // Se o CPF/CNPJ estiver bloqueado, abre o Dialog e interrompe a ação
    if (bloqueioPorCPFCNPJ) {
      setOpenDialog(true);
      return;
    }
    const formularioAtual = refs.current[etapa].current;

    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (formularioAtual.validarFormulario()) {
      setErroValidacao(false);
      atualizaDadosEtapa();

      if (etapa < formularios.length - 1) {
        setEtapa(etapa + 1);
      } else {
        setTimeout(() => {
          setFinalizado(true);
        }, 200);
      }
    } else {
      setErroValidacao(true);
    }
  };

  const voltarEtapa = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (etapa > 0) {
      setEtapa(etapa - 1);
      setErroValidacao(false);
      atualizaDadosEtapa();
    }
  };

  const atualizaDadosEtapa = () => {
    const formularioAtual = refs.current[etapa].current;
    const dados = formularioAtual.getDados();

    setDadosFormulario((prev) => {
      const updated = [...prev];
      updated[etapa] = dados;

      if (etapa === 1 && props.tipo === 'pf')
        updated[0].tipoFiliacao = dados?.nacionalidade?.id === 76 ? 'nacional' : 'estrangeiro';

      return updated;
    });

    return dados;
  };

  useEffect(() => {
    if (finalizado) {
      salvandoFiliacao();
    }
  }, [finalizado]);

  useEffect(() => {
    if (nrFiliacao > 0 && finalizado) {
      salvandoArquivos();
    }
  }, [nrFiliacao]);

  const salvandoFiliacao = async () => {
    try {
      setIsLoading(true);

      const dtoEnvio = {
        ...mapeamentoEtapaUmPF(dadosFormulario[0], props.tipo.toUpperCase()),
        ...mapeamentoEtapaDoisPF(dadosFormulario[1]),
        ...mapeamentoEtapaTres(dadosFormulario[2]),
        ...mapeamentoEtapaQuatro(dadosFormulario[3]),
        ...mapeamentoEtapaCinco(dadosFormulario[4], dadosFormulario[0]?.tipoFiliacao),
        ...{ HashDadosForm: localStorage.getItem("dadosFormulario") }
      };

      const idFiliacao = await serviceCriarFiliacao(dtoEnvio);

      if (idFiliacao && idFiliacao > 0) {
        setNrFiliacao(idFiliacao);
        serviceSalvarLog('salvandoFiliacao', 'Filiação criada. filiação: ' + idFiliacao, localStorage.getItem("dadosFormulario"), 'INFO', trackId);
      }
    } catch (error) {
      setIsLoading(false);
      setFinalizado(false);
      await serviceSalvarLog('salvandoFiliacao', `Erro ao criar filiação: ${error.message}`, JSON.stringify({ stack: error.stack }), 'ERROR', trackId);
      alert('Ocorreu um erro ao tentar salvar a sua filiação');
    }
  };

  const salvandoArquivos = async () => {
    try {

      await serviceSalvarArquivos(
        mapeamentoEtapaArquivos(dadosFormulario[5], nrFiliacao, null, trackId)
      );

      await salvaDocumentoParaAssinatura(nrFiliacao);

      await serviceEnviaEmail({
        idFiliacao: nrFiliacao.toString(),
        email: dadosFormulario[2].email,
        nome:
          props.tipo === 'pf'
            ? dadosFormulario[1]?.nomeCompleto
            : dadosFormulario[1]?.razaoSocial,
      });

      setIsLoading(false);
      setSucesso(true);
      clearLocalStorage();
    } catch (error) {
      setIsLoading(false);
      setSucesso(true);
      serviceSalvarLog('salvandoArquivos', JSON.stringify({ message: error.message, stack: error.stack }), '', 'ERROR', trackId);
      clearLocalStorage();
    }
  };

  const salvaDocumentoParaAssinatura = async (_idFiliacao) => {
    const container = pdfRef.current;

    const pdfBlob = await html2pdf()
      .from(container)
      .set({
        margin: 20,
        filename: 'Desligamentos.pdf',
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: 'css' },
      })
      .output('blob');

    return await serviceSalvarArquivos(
      mapeamentoEtapaArquivos(null, _idFiliacao, pdfBlob, trackId)
    );
  }

  const estiloFaixaImpressao = {
    widtth: '100%',
    padding: '10px',
    'background-color': 'black',
    color: 'white',
    'text-transform': 'uppercase',
    'text-align': 'center',
  };

  const cssQuebraPagina = {
    'page-break-after': 'auto',
    'break-after': 'page',
    width: '100%',
  };

  return (
    <Box sx={{ bgcolor: '#f0f0f0', minHeight: '100vh', p: 3 }}>
      <TelaLoadind isVisible={isLoading} />

      {erroValidacao && (
        <Box
          sx={{
            position: 'fixed',
            top: 10,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1200,
          }}
        >
          <Alert severity="error" onClose={() => setErroValidacao(false)}>
            Por favor, preencha todos os campos obrigatórios.
          </Alert>
        </Box>
      )}

      {/* Dialog para informar cadastro recente */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="dialog-titulo"
      >
        <DialogTitle id="dialog-titulo">Cadastro Recente</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Caro(a) Usuário, em nossos registros consta que você já tentou efetuar o processo de filiação a menos de 3 meses atrás. Caso sua proposta de filiação tenha sido negada a menos de 3 meses, favor aguardar o prazo para nova tentativa. Caso contrário, entrar em contato com uma de nossas filiais.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Container
        maxWidth="md"
        sx={{
          bgcolor: 'white',
          borderRadius: 1,
          p: 3,
          position: 'relative',
          boxShadow: '3px 3px 17px rgba(0,0,0,0.2)',
        }}
        ref={pdfRef}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: -50,
          }}
        >
          <img src="logo.png" alt="Minha Logo" style={{ height: '50px' }} />
        </Box>

        {!sucesso ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}>
            <Box>
              {nrFiliacao === 0 && (
                <Typography variant="h5" gutterBottom>
                  Etapa {etapa + 1} de {formularios.length}
                </Typography>
              )}
              <Typography variant="h4" gutterBottom style={{ color: '#1c5bbe' }}>
                Formulário de Filiação à UBC
              </Typography>
            </Box>
            {nrFiliacao === 0 && !sucesso && (
              <Box sx={{ flexGrow: 1, overflow: 'auto' }}>{formularios[etapa]}</Box>
            )}
            {nrFiliacao > 0 && !sucesso && (
              <>
                <div style={estiloFaixaImpressao}>
                  Numero da Proposta: {idFiliacaoUrl || nrFiliacao} | Data:{' '}
                  {dataHoraUrl || moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}
                </div>
                <div style={estiloFaixaImpressao}>
                  Proposta de Filiação // {props.tipo === 'pf' ? 'Pessoa Física' : 'Pessoa Jurídica'}
                </div>
              </>
            )}
            {nrFiliacao > 0 && !sucesso && (
              <>
                {formularios.map((form, i) => (
                  <>
                    {i > 0 && (
                      <>
                        <div style={cssQuebraPagina}></div>
                        <Box sx={{ position: 'relative', height: '10px' }}>
                          <img
                            src="logo.png"
                            alt="Minha Logo"
                            style={{ position: 'absolute', top: 10, right: -20, height: '30px' }}
                          />
                        </Box>
                      </>
                    )}
                    <Box key={i}>{form}</Box>
                  </>
                ))}
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                  <Box
                    sx={{
                      width: '100%',
                      margin: '20px auto',
                      borderBottom: '1px solid #000',
                      maxWidth: 300,
                    }}
                  />
                  <Typography>Assinatura</Typography>
                  <Typography>
                    {(props.tipo === 'pf'
                      ? dadosFormulario[1]?.nomeCompleto || ''
                      : dadosFormulario[1]?.razaoSocial || ''
                    ).toUpperCase()}{' '}
                    {props.tipo === 'pf' ? dadosFormulario[1]?.cpf : dadosFormulario[1]?.cnpj}
                  </Typography>
                </Box>
              </>
            )}
            {nrFiliacao > 0 && !sucesso && (
              <container>
                <TelaDesligamentos
                  dados={dadosFormulario[0]}
                  dadosPessoa={{
                    nome:
                      props.tipo === 'pf'
                        ? dadosFormulario[1]?.nomeCompleto
                        : dadosFormulario[1]?.razaoSocial,
                    cpf: props.tipo === 'pf' ? dadosFormulario[1]?.cpf : dadosFormulario[1]?.cnpj,
                  }}
                />
              </container>
            )}
            {nrFiliacao === 0 && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {etapa > 0 && (
                  <Button variant="contained" onClick={voltarEtapa}>
                    Voltar
                  </Button>
                )}
                <Button variant="contained" color="primary" onClick={avancarEtapa}>
                  {etapa === formularios.length - 1 ? 'Finalizar' : 'Próximo'}
                </Button>
              </Box>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '60vh',
              gap: 3,
            }}
          >
            <Typography variant="h4" color="success.main" sx={{ fontWeight: 'bold' }}>
              Cadastro realizado com sucesso! O número do seu protocolo é: {nrFiliacao}
            </Typography>
            <Typography variant="h6">
              Você será redirecionado para o site da UBC em <strong>{countdown}</strong> segundos...
            </Typography>
            <Alert severity="success" variant="filled" sx={{ fontSize: '1.2rem' }}>
              Agradecemos a sua filiação e em breve entraremos em contato.
            </Alert>
          </Box>
        )}

      </Container>
    </Box>
  );
}

export default Orquestrador;
